// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vdncu","colBig":"styles_colBig__1y6YK","colSmall":"styles_colSmall__VO43w"};